export enum BalanceAccountIds {
    BALANCE_ACCOUNT_ID = '0'
}
